import React from 'react';
import PropTypes from 'prop-types';

export class Container extends React.Component {
    static propTypes = {
        hasOuterGutter: PropTypes.bool,
        hasGutter: PropTypes.bool,
        classNames: PropTypes.string
    }

    static defaultProps = {
        hasOuterGutter: true,
        hasGutter: true,
        classNames: ''
    }

    render() {
        const rootClassNames = ['row']

        // .row includes a gutter and an outer gutter so we don't need
        // to enable them, just disable.
        if (this.props.hasOuterGutter === false)
            rootClassNames.push('row-no-outer-gutter')
        if (this.props.hasGutter === false)
            rootClassNames.push('row-no-gutter')

        return (
            <div className={rootClassNames.join(' ') + (this.props.className ? ' ' + this.props.className : '')}
                 style={this.props.style}>
                {this.props.children}
            </div>
        )
    }
}

/**
 * Creates a function component representing a column of specified size.
 *
 * @param {Number} size 1 through 12
 * @return {Function}
 */
const createColumnComponent = size => {
    if (size < 1 || size > 12) {
        throw new Error(`Invalid column size: ${size}`);
    }

    return function (props) {
        if (props.hidden) {
            return <React.Fragment></React.Fragment>;
        }

        const classNames = ['column-' + size]

        if (props.className) {
            classNames.push(props.className)
        }

        return <div className={classNames.join(' ')} style={props.style}>{props.children}</div>;
    };
}

// ES6 only allows top-level exports so there's no way
// to put this in a loop. 
export const Column1 = createColumnComponent(1);
export const Column2 = createColumnComponent(2);
export const Column3 = createColumnComponent(3);
export const Column4 = createColumnComponent(4);
export const Column5 = createColumnComponent(5);
export const Column6 = createColumnComponent(6);
export const Column7 = createColumnComponent(7);
export const Column8 = createColumnComponent(8);
export const Column9 = createColumnComponent(9);
export const Column10 = createColumnComponent(10);
export const Column11 = createColumnComponent(11);
export const Column12 = createColumnComponent(12);
